export enum ComponentType
{
    None = "None",
    Update = "Update",
    Install = "Install",
    New = "New",
}